import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../Api.js';
import img1 from "../assets/oneclick-new-logo-light.png";
import './Footer.css';

const companyLinks = [
  { label: 'About Us', to: '/about' },
  { label: 'How it Works', to: '/how-it-works' },
  { label: 'Careers', to: '/careers' },
  { label: 'Contact', to: '/contact' }
];

const supportLinks = [
  { label: 'Help Center', to: '/help-center' },
  { label: 'Terms & Conditions', to: '/terms-and-conditions' },
  { label: 'Privacy Policy', to: '/privacy-policy' }
];

const Footer = () => {
  const [services, setServices] = useState([]);
  const [servicesError, setServicesError] = useState(false);
  const [servicesLoading, setServicesLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadServices = async () => {
      try {
        const response = await api.get('/api/web/available-services');
        const availableServices = response.data?.data?.services;
        if (!Array.isArray(availableServices)) {
          throw new Error('The services response did not contain a services list.');
        }

        if (!cancelled) {
          setServices(availableServices.filter((service) => (
            service.status === true && service._id && service.availableserviceTitle
          )));
          setServicesError(false);
          setServicesLoading(false);
        }
      } catch (error) {
        console.error('Error loading footer services:', error);
        if (!cancelled) {
          setServicesError(true);
          setServicesLoading(false);
        }
      }
    };

    loadServices();
    return () => {
      cancelled = true;
    };
  }, []);

  const renderLinks = (links) => (
    <ul>
      {links.map((link) => (
        <li key={link.to}>
          <Link to={link.to}>{link.label}</Link>
        </li>
      ))}
    </ul>
  );

  return (
    <footer className="site-footer">
      <div className="site-footer__container">
        <div className="site-footer__about">
          <div className="site-footer__logo">
            <Link to="/">
              <img src={img1} alt="OneClick home" />
            </Link>
          </div>
          <p>Your trusted platform to find skilled tradies across Australia. Fast, reliable, and just one click away.</p>
          <div className="site-footer__contact-links">
            <a href="mailto:oneclickservs@gmail.com">Email us</a>
            <a href="tel:+918240316090">Call us</a>
          </div>
        </div>

        <div className="site-footer__column">
          <h3>Services</h3>
          {servicesError ? (
            <p className="site-footer__status" role="status">
              Services could not be loaded. <Link to="/services">Browse all services</Link>
            </p>
          ) : services.length ? (
            renderLinks([
              ...services.slice(0, 6).map((service) => ({
                label: service.availableserviceTitle,
                to: `/services/${service._id}`
              })),
              { label: 'View all services', to: '/services' }
            ])
          ) : servicesLoading ? (
            <p className="site-footer__status" role="status">Loading services…</p>
          ) : (
            <p className="site-footer__status">
              No services are available right now. <Link to="/services">Browse services</Link>
            </p>
          )}
        </div>

        <div className="site-footer__column">
          <h3>Company</h3>
          {renderLinks(companyLinks)}
        </div>

        <div className="site-footer__column">
          <h3>Support</h3>
          {renderLinks(supportLinks)}
        </div>
      </div>

      <div className="site-footer__bottom">
        <p>© {new Date().getFullYear()} OneClick. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;